export const forCastCard = {
  display: 'flex',
  flexDirection: 'column',
  padding: '15px 0px 0px 10px',

  borderRadius: '8px',
  boxShadow: 'none',
  // margin:"0px 10px"
};
export const centerContent = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '5px 10px 15px 10px',
};
export const postCntl = {
  display: 'flex',
  padding: '10px',
  justifyContent: 'center',
  alignItems: 'center',
};
